import React from "react";
import EventCard from "./EventCard";

export default function EventList({ events, variant = "standard", className = "" }) {
  return (
    <div className={`grid min-w-0 gap-4 md:grid-cols-2 ${className}`} data-event-list="true">
      {events.map((event) => (
        <EventCard key={event.id} event={event} variant={variant} />
      ))}
    </div>
  );
}
